import { useEffect } from 'react'
import { debounce } from 'debounce'
import { useDispatch, useSelector } from 'react-redux'
import { getWindowSize } from '~/selectors/ui'
import { setWindowSize } from '~/actions/ui'

const useWindowSize = () => {
  const dispatch = useDispatch()
  const windowSize = useSelector(getWindowSize)
  const getSize = () => ({
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  })

  useEffect(() => {
    const handleResize = debounce(() => {
      dispatch(setWindowSize(getSize()))
    }, 1000)

    window.addEventListener('resize', handleResize)

    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowSize
}

export default useWindowSize
